import { renderInputsOfAudioNode } from '../helpers/render-inputs-of-audio-node';
export const createAudioDestinationNodeRenderer = () => {
    let nativeAudioDestinationNode = null;
    return {
        render: async (proxy, nativeOfflineAudioContext) => {
            if (nativeAudioDestinationNode !== null) {
                return nativeAudioDestinationNode;
            }
            nativeAudioDestinationNode = nativeOfflineAudioContext.destination;
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioDestinationNode);
            return nativeAudioDestinationNode;
        }
    };
};
//# sourceMappingURL=/build/es2018/factories/audio-destination-node-renderer-factory.js.map